import { readItem, writeItem } from "@bindery/shared/web-storage";
import { useSyncExternalStore } from "react";
import { storageKey } from "@/site";

// Device-local by design (D14): a nickname never leaves the device.
export const nicknameKey = (readerId: string): string =>
  storageKey(`nickname.v1:${readerId}`);

const listeners = new Set<() => void>();

export function readNickname(readerId: string): string | null {
  return readItem(nicknameKey(readerId));
}

/** False when storage refused the write (Safari private mode). */
export function writeNickname(readerId: string, nickname: string): boolean {
  if (!writeItem(nicknameKey(readerId), nickname)) return false;
  for (const listener of listeners) listener();
  return true;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  window.addEventListener("storage", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", listener);
  };
}

export function useNickname(readerId: string): string | null {
  return useSyncExternalStore(
    subscribe,
    () => readNickname(readerId),
    () => null,
  );
}
